module.exports = __webpack_public_path__ + "static/img/UBC教室_3.66a7cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC教室_3.png
// module id = iVYc
// module chunks = 0